import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
require('./interceptors')

export const SERVER_URL = process.env.VUE_APP_API_URL

export class Jwt {
  static accessToken (email, password) {
    return Vue.http.post(SERVER_URL + '/v1/auth/login', { email, password })
  }

  static refreshToken () {
    return Vue.http.post(SERVER_URL + '/v1/auth/refresh_token')
  }

  static unauthenticate () {
    console.log('jwt unauthenticate')
    return Vue.http.post(SERVER_URL + '/v1/auth/logout')
  }
}

export class ResetPassword {
  static request (formData) {
    return Vue.http.post(SERVER_URL + '/v1/auth/reset_password', formData)
  }

  static getUserByToken (token) {
    return Vue.http.get(SERVER_URL + '/v1/auth/recover_user_by_token/' + token)
  }

  static resetPassword (formData) {
    return Vue.http.post(SERVER_URL + '/v1/auth/save_new_password', formData)
  }
}

export class Step {
  static getStep (stepId) {
    return Vue.http.get(SERVER_URL + `/v1/steps/${stepId}`)
  }
}

export class Enrollment {
  static getEnrollmentExerciseList (enrollmentId, stepId) {
    return Vue.http.get(SERVER_URL + `/v1/enrollment/${enrollmentId}/step/${stepId}/exercise-list`)
  }
}

export class Event {
  static eventSessions (eventId, limit) {
    const params = limit ? { limit: limit } : {}
    return Vue.http.get(SERVER_URL + `/v1/event/${eventId}/event-sessions`, {
      params: params
    })
  }

  static events (limit) {
    const params = limit ? { limit: limit } : {}
    return Vue.http.get(SERVER_URL + '/v1/events', {
      params: params
    })
  }
}

export class Student {
  static eventSessions (limit) {
    const params = limit ? { limit: limit } : {}
    return Vue.http.get(SERVER_URL + '/v1/student/event-sessions', {
      params: params
    })
  }

  static subscribeEventSession (studentId, eventSessionId, limit) {
    const params = limit ? { limit: limit } : {}
    return Vue.http.post(SERVER_URL + `/v1/student/${studentId}/event-session/${eventSessionId}/subscribe`, {
      params: params
    })
  }

  static unsubscribeEventSession (studentId, eventSessionId, limit) {
    const params = limit ? { limit: limit } : {}
    return Vue.http.delete(SERVER_URL + `/v1/student/${studentId}/event-session/${eventSessionId}/unsubscribe`, {
      params: params
    })
  }
}

export class Course {
  static list () {
    return Vue.http.get(SERVER_URL + '/v1/course')
  }

  static groups (limit) {
    const params = limit ? { limit: limit } : {}
    return Vue.http.get(SERVER_URL + '/v1/groups', {
      params: params
    })
  }

  static getEnrollmentGrade (enrollmentId) {
    return Vue.http.get(SERVER_URL + '/v1/enrollment/show-enrollment-grade', {
      params: {
        enrollment_id: enrollmentId
      }
    })
  }

  static getGroupTests (groupId) {
    return Vue.http.get(SERVER_URL + `/v1/groups/${groupId}/tests`)
  }

  static getEnrollmentSteps (groupId, enrollmentId) {
    return Vue.http.get(SERVER_URL + `/v1/groups/${groupId}/enrollment/${enrollmentId}/tests`)
  }

  static getStudentLessonDays () {
    return Vue.http.get(SERVER_URL + '/v1/enrollment/get-student-lesson-days')
  }
}

export class SalaDeAula {
  static getSyllabus (matriculaId) {
    return Vue.http.get(SERVER_URL + '/v1/course/' + matriculaId)
  }

  static getLesson (matriculaId, aulaId) {
    return Vue.http.get(SERVER_URL + '/v1/enrollment/lesson/' + matriculaId + '/' + aulaId)
  }

  static updateLessonProgress (matriculaId, aulaId, progresso) {
    return Vue.http.post(SERVER_URL + '/v1/enrollment/update-lesson-progress/', {
      _method: 'patch', enrollment_id: matriculaId, lesson_id: aulaId, progress: progresso
    }, {
      hideLoader: true
    })
  }

  static getExerciseList (matriculaId, aulaId) {
    return Vue.http.post(SERVER_URL + '/v1/exercise-list-instance/get-exercise-list', {
      enrollment_id: matriculaId,
      lesson_id: aulaId
    })
  }

  static getExercise (exerciseListInstanceExerciseId) {
    return Vue.http.get(SERVER_URL + '/v1/exercise-list-instance/get-exercise', {
      params: {
        exercise_list_instance_exercise_id: exerciseListInstanceExerciseId
      }
    })
  }

  static closeTestExercises (answer) {
    console.log(answer)
    return Vue.http.post(SERVER_URL + '/v1/exercise-list-instance/close-test-exercises', answer, { hideLoader: true })
  }

  static answerTestExercise (answer) {
    return Vue.http.post(SERVER_URL + '/v1/exercise-list-instance/answer-test-exercise', answer, { hideLoader: true })
  }

  static answerExercise (answer) {
    return Vue.http.post(SERVER_URL + '/v1/exercise-list-instance/answer-exercise', answer, { hideLoader: true })
  }

  static getLastLessonData () {
    return Vue.http.get(SERVER_URL + '/v1/enrollment/get-last-lasson-data')
  }
}

export class Profile {
  static changePassword (form) {
    return Vue.http.post(SERVER_URL + '/v1/auth/change-pass', form)
  }
}

export class File {
  static uploadFile (formData) {
    return Vue.http.post(SERVER_URL + '/v1/file/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }

  static deleteFile (fileName) {
    return Vue.http.post(SERVER_URL + '/v1/file/delete', { file: fileName })
  }
}

export class AuthFile {
  static getFile (fileName) {
    return Vue.http.get(SERVER_URL + '/v1/file/get-file', {
      params: {
        file_name: fileName
      },
      responseType: 'blob'
    })
  }

  static getFileById (fileId) {
    return Vue.http.get(SERVER_URL + '/v1/file/get-file-by-id', {
      params: {
        file_id: fileId
      },
      responseType: 'blob'
    })
  }
}

export class Forum {
  static listAllForums () {
    return Vue.http.get(SERVER_URL + '/v1/forum/list-all')
  }

  static getTopicsByForum (forumId, pageNumber) {
    return Vue.http.get(SERVER_URL + '/v1/forum/get-topics-by-forum', {
      params: {
        forum_id: forumId,
        page_number: pageNumber
      }
    })
  }

  static getForumTopic (topicId) {
    return Vue.http.get(SERVER_URL + '/v1/forum/get-forum-topic', {
      params: {
        topic_id: topicId
      }
    })
  }

  static discussionsFromForumTopic (topicId, pageNumber) {
    return Vue.http.get(SERVER_URL + '/v1/forum/get-discussions-from-forum-topic', {
      params: {
        topic_id: topicId,
        page_number: pageNumber
      }
    })
  }

  static saveDiscussionInForumTopic (params) {
    return Vue.http.post(SERVER_URL + '/v1/forum/save-discussion-in-forum-topic', params)
  }

  static updateDiscussionInForumTopic (params) {
    return Vue.http.patch(SERVER_URL + '/v1/forum/update-discussion-in-forum-topic', params)
  }

  static getForumTopicDiscussion (discussionId) {
    return Vue.http.get(SERVER_URL + '/v1/forum/get-forum-topic-discussion', {
      params: {
        discussion_id: discussionId
      }
    })
  }

  static saveReplyInDiscussion (params) {
    return Vue.http.post(SERVER_URL + '/v1/forum/save-reply-in-discussion', params)
  }

  static updateReplyInDiscussion (params) {
    return Vue.http.patch(SERVER_URL + '/v1/forum/update-reply-in-discussion', params)
  }

  static getDiscussionReply (replyId) {
    return Vue.http.get(SERVER_URL + '/v1/forum/get-discussion-reply', {
      params: {
        reply_id: replyId
      }
    })
  }

  static repliesFromDiscussion (discussionId, pageNumber) {
    return Vue.http.get(SERVER_URL + '/v1/forum/get-replies-from-discussion', {
      params: {
        discussion_id: discussionId,
        page_number: pageNumber
      }
    })
  }
}

export class Transaction {
  static fetch (enrollmentId) {
    return Vue.http.get(SERVER_URL + '/v1/enrollment/' + enrollmentId + '/transactions/')
  }
}

export class User {
  static get () {
    return Vue.http.get(SERVER_URL + '/v1/auth/user')
  }

  static firstAccessVerify (params) {
    return Vue.http.post(SERVER_URL + '/v1/auth/first-access-verify', params)
  }

  static firstAccessRegister (params) {
    return Vue.http.post(SERVER_URL + '/v1/auth/first-access-register', params)
  }

  static register (params) {
    return Vue.http.post(SERVER_URL + '/v1/auth/register', params)
  }

  static order (params) {
    return Vue.http.post(SERVER_URL + '/v1/orders', params)
  }
}

export class State {
  static get () {
    return Vue.http.get(SERVER_URL + '/v1/states')
  }

  static cities (state) {
    return Vue.http.get(SERVER_URL + `/v1/states/${state}/cities`)
  }
}

export class Unit {
  static show (unit) {
    return Vue.http.get(SERVER_URL + `/v1/unities/${unit}`)
  }
}

export class CoursePackage {
  static show (coursePackage) {
    return Vue.http.get(SERVER_URL + `/v1/course-packages/${coursePackage}`)
  }
}

export class Application {
  static async info () {
    return Vue.http.get(SERVER_URL + '/v1/info-app')
  }
}
